/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ThumbsUpFilledIcon = /*#__PURE__*/ createSvgIcon(
  'ThumbsUpFilledIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M17.5 7c.375 0 .719.153 1.031.458.313.306.469.653.469 1.042v1.187a1.348 1.348 0 01-.125.584l-2.48 5.812c-.11.278-.29.5-.54.667-.25.167-.536.25-.855.25H7c-.417 0-.77-.142-1.063-.427A1.437 1.437 0 015.5 15.5V7.625c0-.208.042-.406.125-.594a1.61 1.61 0 01.333-.49l4.188-4.187c.25-.25.555-.41.916-.479.362-.07.667-.028.917.125.32.18.525.444.615.792.09.347.1.687.031 1.02L12 7h5.5zm-15 10a1.44 1.44 0 01-1.052-.448A1.44 1.44 0 011 15.5v-7c0-.403.15-.753.448-1.052A1.44 1.44 0 012.5 7c.403 0 .753.15 1.052.448.299.299.448.65.448 1.052v7c0 .403-.15.753-.448 1.052A1.44 1.44 0 012.5 17z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ThumbsUpFilledIcon;
